import Marquee from 'react-fast-marquee';

const items = [
  '5-STAR RATED',
  'FREE BREAKFAST & LUNCH',
  '100+ HOTEL PICKUPS',
  'LUXURY AIR-CONDITIONED VEHICLES',
  'SANTA MONICA BEACH',
  'BEVERLY HILLS & RODEO DRIVE',
  'HOLLYWOOD WALK OF FAME',
  'WARNER BROS STUDIOS',
  'CELEBRITY MANSIONS',
  'SINCE 2010',
  'INSTANT CONFIRMATION',
  'BEST PRICE GUARANTEE',
];

const MarqueeBanner = () => {
  return (
    <div className="bg-[#FFD600] border-y-2 border-black py-3 overflow-hidden" data-testid="marquee-banner">
      <Marquee speed={50} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="font-bebas text-lg sm:text-xl tracking-wider text-black mx-6 sm:mx-8">
            <span className="text-[#FF007A] mr-2">&#9733;</span>
            {item}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBanner;
